import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ATTENDANCEALL } from '../../services/actions';
import { Box, Typography, Container, Paper } from '@mui/material';
import XTable from '../extra/XTableAnother';
import ActionBar from '../extra/ActionBar';

export default function AttendanceReport() {
    const dispatch = useDispatch();
    const attendanceAllState = useSelector(state => state.attendanceallState);
    const auth = useSelector(state => state.loginState?.auth);
    const logs = Array.isArray(attendanceAllState?.data) ? attendanceAllState.data : (attendanceAllState?.data?.results || []);

    // Check if user is a manager/admin who can see all records
    const isManager = auth?.is_superuser || 
        (auth?.group && auth.group.some(g => ["Manager", "Admin", "IT Manager", "SuperAdmin"].includes(g?.name || g)));

    useEffect(() => {
        dispatch({ type: `${ATTENDANCEALL}_GET`, payload: "attendance/logs/" });
    }, [dispatch]);

    const calculateTime = (start, end, log) => {
        if (!start) return { hours: 0, text: '-' };
        let startTimeObj = new Date(start);
        let endTimeObj = end ? new Date(end) : new Date();

        const wt = log?.working_time || { start_time: "09:00:00", end_time: "18:00:00" };
        const [sH, sM, sS = 0] = wt.start_time.split(':').map(Number);
        const [eH, eM, eS = 0] = wt.end_time.split(':').map(Number);
        
        const startLimit = new Date(startTimeObj);
        startLimit.setHours(sH, sM, sS, 0);
        
        const endLimit = new Date(startTimeObj);
        endLimit.setHours(eH, eM, eS, 0);

        if (startTimeObj < startLimit) {
            startTimeObj = startLimit;
        }
        if (endTimeObj > endLimit) {
            endTimeObj = endLimit;
        }

        const diffMs = endTimeObj - startTimeObj;
        if (diffMs <= 0 || isNaN(diffMs)) return { hours: 0, text: '0h 0m' };
        
        const totalMinutes = Math.floor(diffMs / (1000 * 60));
        const hours = Math.floor(totalMinutes / 60);
        const mins = totalMinutes % 60;
        
        const statusText = !end ? ` (Active)` : '';
        return { hours: diffMs / (1000 * 60 * 60), text: `${hours}h ${mins}m${statusText}` };
    };

    const getDayStatus = (hours) => {
        if (hours === 0) return <span style={{ color: 'gray' }}>-</span>;
        if (hours > 9) return <span style={{ color: '#9c27b0', fontWeight: 'bold' }}>Overtime</span>;
        if (hours >= 8) return <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>Full Day</span>;
        return <span style={{ color: '#ed6c02', fontWeight: 'bold' }}>Short / Half Day</span>;
    };

    const tableHeadings = [
        ...(isManager ? ["User"] : []),
        "Date",
        "Punch In",
        "Punch Out",
        "Available Working Time",
        "Day Status",
        "Log Status"
    ];

    const tableRows = logs.map(log => {
        const timeData = calculateTime(log.punch_in_time, log.punch_out_time, log);
        const row = {};
        if (isManager) {
            row.user_name = log.user_name || `User #${log.user}`;
        }
        row.date = log.date || '-';
        row.punch_in = log.punch_in_time ? new Date(log.punch_in_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '-';
        row.punch_out = log.punch_out_time ? new Date(log.punch_out_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : (log.punch_in_time ? <span style={{ color: '#0288d1', fontWeight: 600 }}>Active</span> : '-');
        row.total_time = <span style={{ fontWeight: 'bold', color: timeData.hours > 9 ? '#9c27b0' : (!log.punch_out_time ? '#0288d1' : 'inherit') }}>{timeData.text}</span>;
        row.day_status = getDayStatus(timeData.hours);
        row.status = log.status || '-';
        return row;
    });

    return (
        <Container maxWidth="false" className="py-3">
            <ActionBar
                showGrid={[2]}
                btnImport=""
                label="Attendance Report"
                setOpen={() => {}}
                hasPermission={false}
                btnLabel=""
            />
            <Paper elevation={0} sx={{ mt: 2 }}>
                <XTable
                    head={tableHeadings}
                    rows={tableRows}
                />
            </Paper>
        </Container>
    );
}
